import React, { useState } from 'react';
import { FaArrowRightToBracket, FaFileInvoiceDollar, FaGear, FaReceipt, FaUserGear } from 'react-icons/fa6';

import { useAuth0 } from '@auth0/auth0-react';
import { Avatar, Divider, IconButton, Menu } from '@mui/material';

import { ReactComponent as ContractIcon } from 'assets/icons/Contract.svg';
import { ReactComponent as SubscriptionIcon } from 'assets/icons/Subscription.svg';

// import { useAuthentication } from 'hooks/useAuthentication';
import { MenuItemIcon } from 'shared/Menu/MenuItemIcon';
import { useTheme } from 'themes/themeProvider';

type Props = {
  imageUrl?: string;
};

export const UserMenu = ({ imageUrl }: Props) => {
  // const { handleLogout } = useAuthentication();
  const { theme } = useTheme();
  const { logout } = useAuth0();

  // State for handling the menu open/close
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const onDropDown = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  // const logout = async () => {
  // try {
  //   const data = await this.post('iam/auth/logout', {});
  //   // console.log(data);
  //   if (data.logoutUrl) {
  //     window.location.href = data.logoutUrl + window.location.origin;
  //     return true;
  //   } else {
  //     throw new Error('Redirect URL is missing');
  //   }
  // } catch (error) {
  //   // console.log(error.message);
  //   throw new Error(`Failed to logout: ${error.message}`);
  // }
  // };

  const onLogout = () => {
    onDropDownClose();
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const onDropDownClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={onDropDown}>
        {imageUrl ? (
          <Avatar
            src={imageUrl || ''}
            alt='user-avatar'
            sx={{
              bgcolor: theme.headerTextColor, // Background color for Avatar if no image
              width: 32,
              height: 32,
            }}
          />
        ) : (
          <FaUserGear size={32} color={theme.headerTextColor} />
        )}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onDropDownClose}
        MenuListProps={{
          sx: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
        sx={{
          borderRadius: '16px',
          p: 0,
        }}
      >
        <MenuItemIcon
          to='invoices'
          icon={<FaFileInvoiceDollar size={24} />}
          text='Invoices'
          onClick={onDropDownClose}
        />

        <MenuItemIcon to='billing' icon={<FaReceipt size={24} />} text='Billing' onClick={onDropDownClose} />

        {/* <MenuItemIcon
          icon={<FaMoneyBills size={24} />}
          text='Tax Reporting'
          to='tax-reporting'
          onClick={onDropDownClose}
        /> */}

        <MenuItemIcon
          icon={<ContractIcon width={24} height={24} />}
          text='Contracts'
          to='contracts'
          onClick={onDropDownClose}
        />

        <MenuItemIcon
          icon={<SubscriptionIcon width={24} height={24} />}
          text='Subscriptions'
          to='subscriptions'
          onClick={onDropDownClose}
        />

        <MenuItemIcon icon={<FaGear size={24} />} text='Settings' to='profile-settings' onClick={onDropDownClose} />

        <Divider />
        <MenuItemIcon to='/' icon={<FaArrowRightToBracket size={24} />} text='Log out' onClick={onLogout} />
      </Menu>
    </div>
  );
};
